export const aracMuayenePage = () => `
  <section class="page-content service-page">
    <div class="container">
      <div class="service-header">
        <h1 class="page-title">Araç Muayene Hizmetleri</h1>
        <p class="page-subtitle">Araç muayene sürecinizi kolaylaştırıyoruz. Randevudan ön kontrole, evrak hazırlığından muayeneye götürme hizmetine kadar yanınızdayız.</p>
      </div>

      <div class="service-list">
        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
          </div>
          <div class="service-info">
            <h3>Muayene Randevu Hizmeti</h3>
            <p>TÜVTÜRK üzerinden hızlı randevu alma, size en yakın istasyondan uygun tarih ayarlama ve yoğunluk durumuna göre en erken randevu takibi yapıyoruz.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><path d="M9 11l3 3L22 4"></path><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg>
          </div>
          <div class="service-info">
            <h3>Ön Kontrol (Muayene Öncesi Check-Up)</h3>
            <p>Muayeneden ilk seferde geçmenizi sağlamak için fren sistemi, far ve sinyal ayarları, lastik durumu, egzoz ve emisyon kontrolü yapıyoruz. Eksik veya kusurlu parçaları tespit ediyoruz.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line></svg>
          </div>
          <div class="service-info">
            <h3>Evrak Kontrol ve Hazırlık</h3>
            <p>Ruhsat kontrolü, trafik sigortası poliçe kontrolü, vergi borcu sorgulama ve eksik evrakların tamamlanması hizmetlerini sunuyoruz.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>
          </div>
          <div class="service-info">
            <h3>Muayene Öncesi Mini Onarım</h3>
            <p>Ampul değişimi, silecek değişimi, basit mekanik düzeltmeler ve far ayarı gibi küçük onarımlar ile aracınızı muayeneye hazırlıyoruz.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>
          </div>
          <div class="service-info">
            <h3>Araç Muayeneye Götürme Hizmeti</h3>
            <p>Aracınızı siz uğraşmadan muayeneye götürüyor, sürecin sizin adınıza takip edilmesini sağlıyor ve raporun size teslim edilmesini organize ediyoruz.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
          </div>
          <div class="service-info">
            <h3>Muayene Takip ve Hatırlatma</h3>
            <p>Muayene tarihinizi takip ediyor, gecikme cezası yaşamamanız için önceden uyarı yapıyor ve periyodik takip sistemi ile sürekli yanınızda oluyoruz.</p>
          </div>
        </div>
      </div>

      <div class="service-cta highlight-cta">
        <h2>Sigorta + Muayene Birlikte Paket Hizmet</h2>
        <p>Zaman kaybı yok, tek seferde muayene geçme oranı yüksek, profesyonel destek. Hemen arayın!</p>
        <div class="cta-buttons">
          <a href="tel:+905368949636" class="btn-primary">0536 894 96 36</a>
          <a href="https://wa.me/+905368949636" class="btn-outline" target="_blank" rel="noopener">WhatsApp ile Ulaşın</a>
        </div>
      </div>
    </div>
  </section>
`;
